import React from 'react';
import ChallengesPageShared from '../Challenges/ChallengesPageShared';

const ABSChallenges: React.FC = () => {
  return <ChallengesPageShared challengeType='ABS' />;
};

export default ABSChallenges;
